<template>
  <v-container fill-height fluid class="login-container">
    <div class="top-left-logo">
      <app-logo></app-logo>
    </div>

    <v-row align="center" justify="center" style="margin-top: 5vh">
      <v-col cols="12" sm="10" md="6" lg="4">
        <v-card flat class="login-card rounded-xl mx-auto">
          <v-card-title class="text-center d-block pb-1 pt-8">
            <h1 class="sign-in-title">Reset Password</h1>
          </v-card-title>

          <v-card-subtitle class="text-center dark pb-4 pb-10">
            Enter your email and we will send you a link to reset your password.
          </v-card-subtitle>

          <v-form lazy-validation ref="form" class="px-8 pb-6">
            <v-text-field
              prepend-inner-icon="mdi-at"
              placeholder="Email Address"
              outlined
              class="mb-7 login-field"
              hide-details
              background-color="#ffffff"
              :rules="validate.required('email')"
              type="email"
              v-model="form.email"
            ></v-text-field>

            <v-btn
              block
              rounded
              color="primary"
              height="48"
              dark
              class="mt-8 mb-10 reset-btn"
              elevation="0"
              @click="$refs.form.validate() ? sendPasswordResetLink() : null"
              :loading="loading"
            >
              Continue
            </v-btn>

            <div class="text-center mt-4 mb-3 account-text">
              <a @click="goBack" class="back-link">Back to login form</a>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import AppLogo from "../../../components/Logo";
import FormValidation from "../../../utils/FormValidation";
import ResponseHelper from "../../../utils/ResponseHelper";

export default {
  name: "ForgotPwd",
  components: {
    AppLogo,
  },
  data() {
    return {
      form: {},
      validate: new FormValidation(),
      toast: new ResponseHelper(),
      loading: false,
    };
  },
  methods: {
    ...mapActions("auth", ["forgot_password"]),
    async sendPasswordResetLink() {
      this.loading = true;
      try {
        const response = await this.forgot_password(this.form);
        this.toast.sendSuccess(response);
      } catch (error) {
        this.toast.sendError(error);
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  position: relative;
}

.top-left-logo {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 1;
}

.login-card {
  background-color: white;
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
}

.sign-in-title {
  font-size: 26px;
  font-weight: bold;
  color: #111 !important;
  margin-bottom: 25px;
}

.login-field {
  ::v-deep .v-input__slot {
    min-height: 45px !important;
    border-radius: 8px;
    font-size: 15px;
  }

  ::v-deep .v-input__prepend-inner {
    margin-top: 10px !important;
    margin-right: 8px !important;
  }

  ::v-deep .v-input__append-inner {
    margin-top: 10px !important;
  }
}

.reset-btn {
  font-weight: 700 !important;
  text-transform: none;
  letter-spacing: 0;
  font-size: 16px;
  color: #ffffff !important;
}

.back-link {
  color: #1768f3 !important;
  text-decoration: none;
  font-weight: 700;
}

.account-text {
  color: #111;
  font-size: 14px;
}

.dark {
  color: #222 !important;
}

::v-deep .v-input--selection-controls__ripple {
  display: none !important;
}

::v-deep .v-input--selection-controls .v-input__slot {
  margin-bottom: 0;
}

::v-deep .v-input--checkbox .v-label {
  font-size: 14px !important;
}
</style>
